import React from 'react';
import cx from 'classnames';

import { View } from '@dbk/ui-react-utils'

import './blur-modal-content.css';

export default function Content({ children, className, isPymt, ...other }) {
	return (
		<div>
			<div {...other} className={cx(className, isPymt ? 'CreateModalContent' : 'ModalContent')}>
				<div className="small-12 large-12 column">
					{children}
				</div>
			</div>
		</div>
	);
}
